import { css } from "@emotion/css";

export const navItemHiddenStyles = css`
  display: none !important;
`;
